import { Box, Paper, Typography, IconButton } from '@mui/material'
import { useTheme } from '@mui/material/styles'
import React from 'react'
import SettingsActionBar from './settingsMenu/SettingsActionBar'
import TradeExitSettings from './settingsMenu/sections/TradeExitSettings'
import BacktestSettings from './settingsMenu/sections/BacktestSettings'
import AccountSettings from './settingsMenu/sections/AccountSettings'
import AssessmentIcon from '@mui/icons-material/Assessment'
import CloseIcon from '@mui/icons-material/Close'
import { useApplicationSuiteContext } from '../contexts/ApplicationSuiteProvider'
import PermissionOverlay from '../components/PermissionOverlay'

function BacktestViewPanelContainer({ backtest, goBack, onClose }: any) {
  const { usermeta, canShowcaseViewBacktestSettings, backtestNameOverrides } =
    useApplicationSuiteContext()

  const theme = useTheme()

  if (!backtest) {
    return null
  }

  return (
    <Paper
      elevation={4}
      sx={{
        position: 'relative',
        width: 400,
        height: '100%',
        backgroundColor: theme.palette.background.custom2,
        borderLeft: `1px solid ${theme.palette.divider}`,
        display: 'flex',
        flexDirection: 'column',
        overflow: 'hidden',
      }}
    >
      {/* Header */}
      <Box
        sx={{
          p: 2,
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-between',
          backgroundColor: theme.palette.background.custom4 || '#1e1e1e',
          borderBottom: `1px solid ${theme.palette.divider}`,
        }}
      >
        <Box
          sx={{
            display: 'flex',
            alignItems: 'center',
            gap: 1,
            overflow: 'hidden',
          }}
        >
          <AssessmentIcon />
          <Typography
            variant="h6"
            sx={{
              fontWeight: 'bold',
              textOverflow: 'ellipsis',
              whiteSpace: 'nowrap',
              overflow: 'hidden',
            }}
          >
            {backtestNameOverrides[backtest.id] ?? backtest.backtestSettings.name}
          </Typography>
        </Box>
        {onClose && (
          <IconButton
            onClick={onClose}
            size="small"
            sx={{
              color: theme.palette.text.secondary,
              '&:hover': {
                color: theme.palette.text.primary,
                backgroundColor: 'rgba(255, 255, 255, 0.08)',
              },
            }}
          >
            <CloseIcon />
          </IconButton>
        )}
      </Box>

      <PermissionOverlay
        isVisible={!canShowcaseViewBacktestSettings && backtest.gcid !== usermeta.gcid}
        message="Upgrade to view backtest settings"
      >
        <Box sx={{ flexGrow: 1, overflow: 'auto' }}>
          <Box sx={{ p: 2 }}>
            <BacktestSettings backtest={backtest} />
            {!(!canShowcaseViewBacktestSettings && backtest.gcid !== usermeta.gcid) && (
              <AccountSettings backtest={backtest} />
            )}
            <TradeExitSettings backtest={backtest} />
          </Box>
        </Box>
      </PermissionOverlay>

      {/* Fixed Button Container */}
      <SettingsActionBar backtest={backtest} goBack={goBack} />
    </Paper>
  )
}

export default BacktestViewPanelContainer
